import * as types from './types';
import actions from './actions';
import {
  extend,
  each,
  set
} from 'lodash';

const state = {
  toolBookStatementList:{
    state : '',
    list : [],
    total : undefined
  }
};

const getters = {
  getToolBookStatementList : (state) => state.toolBookStatementList,//结算批次列表

};

const mutations = {
  [types.ACTION_GET_TOOL_BOOK_STATEMENT_LIST]({toolBookStatementList}, result){
    extend(toolBookStatementList,result)
  }
};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/semesterListIndex/index.js